import React from 'react';
import '../styles/Sidebar.css';

const Sidebar = ({ children, isOpen, setIsOpen }) => {
  return (
    <div className={`sidebar ${!isOpen ? 'collapsed' : ''}`}>
      {children}
      <button 
        className="toggle-btn" 
        onClick={() => setIsOpen(!isOpen)}
        title={isOpen ? 'Skjul menu' : 'Vis menu'}
      >
        <i className={`fas fa-chevron-${isOpen ? 'left' : 'right'}`}></i>
      </button>
    </div>
  );
};

export default Sidebar; 